import { BoltSlashIcon } from "@heroicons/react/24/outline";
import { type JSX } from "react";

// We can make this more configurable, but this is just a placeholder for now.
export const GenericError = ({
  message,
  displaySupportTeam = true,
}: {
  message: string;
  displaySupportTeam?: boolean;
}): JSX.Element => {
  return (
    <>
      <BoltSlashIcon className="h-9 w-9 pb-1 text-yellow-300" />
      <p>{message}</p>
      {displaySupportTeam && (
        <p>
          If the issue persists, contact our&nbsp;
          <a className="font-semibold text-indigo-600" href="#">
            support team.
          </a>
        </p>
      )}
    </>
  );
};
